<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        fab
        title="Add New Payment Channel Type"
        v-on="on"
      >
        <v-icon medium>
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Payment Channel Type
            </h4>
            <p class="category font-weight-thin">
              Create Payment Channel Type
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog"
      >
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"  
                label="Name"
              />
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,          
        name: '',
        progressing: false,
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.paymentChannelTypes().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ color: 'success', message: response.data.message })

                  this.dialog = false                
                }
              }).catch(err => {
                this.$snack({ color: 'error', message: err.response.statusText })
              }).then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.name,
        }
      },
    },
  }
</script>
